'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createClassNames = function createClassNames(classNamesObject) {
  var classNames = [];
  for (var key in classNamesObject) {
    if (classNamesObject[key]) {
      classNames.push(key);
    }
  }
  return classNames.join(' ');
};

var CarouselSlide = function (_Component) {
  _inherits(CarouselSlide, _Component);

  function CarouselSlide() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CarouselSlide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CarouselSlide.__proto__ || Object.getPrototypeOf(CarouselSlide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      direction: null
    }, _this.isUnmounted = false, _this.startAnimation = function () {
      if (_this.isUnmounted) {
        return;
      }

      _this.setState({
        direction: _this.props.direction === 'prev' ? 'right' : 'left'
      });
    }, _this.onClick = function () {
      _this.props.onCarouselClick && _this.props.onCarouselClick(_this.props.index);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CarouselSlide, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.active !== nextProps.active) {
        this.setState({ direction: null });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var active = this.props.active;

      var prevActive = prevProps.active;

      if (active !== prevActive) {
        setTimeout(function () {
          return _this2.startAnimation();
        }, 20);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isUnmounted = true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          direction = _props.direction,
          active = _props.active,
          animateIn = _props.animateIn,
          animateOut = _props.animateOut,
          onCarouselClick = _props.onCarouselClick,
          showZoomOverlay = _props.showZoomOverlay;

      var classes = {
        item: true,
        clickable: onCarouselClick && active && !animateIn,
        active: active && !animateIn || animateOut,
        'overlay-container': showZoomOverlay
      };
      if (direction && active && animateIn) {
        classes[direction] = true;
      }
      if (this.state.direction && (animateIn || animateOut)) {
        classes[this.state.direction] = true;
      }

      return _react2.default.createElement(
        'div',
        { onClick: this.onClick, className: createClassNames(classes) },
        this.props.children,
        showZoomOverlay ? _react2.default.createElement(
          'div',
          { className: 'overlay flex-center' },
          _react2.default.createElement(_Icon2.default, { name: 'zoom-in-l', size: '2x', color: _colors.teal.base })
        ) : null
      );
    }
  }]);

  return CarouselSlide;
}(_react.Component);

exports.default = CarouselSlide;


CarouselSlide.propTypes = {
  active: _propTypes2.default.bool,
  index: _propTypes2.default.number,
  animateOut: _propTypes2.default.bool,
  animateIn: _propTypes2.default.bool,
  direction: _propTypes2.default.string,
  onCarouselClick: _propTypes2.default.func,
  showZoomOverlay: _propTypes2.default.bool,
  children: _propTypes2.default.node
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/Carousel/CarouselSlide.js
// module id = 427
// module chunks = 0